import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { compose } from 'recompose';
import { debouncedReduxForm } from 'sharedParts';

import CommentsField from 'components/CommentsField';
import isQuestionCommentsDisabled from 'utils/isQuestionCommentsDisabled';
import genericQuestionPropType from '../../../../config/genericQuestionPropType';
import propTypeBlockStyling from '../../../../domains/styling/config/editorBlock/PropTypes/blockStyling';
import withTakerValidator from '../../hoc/withTakerValidator';

import styles from './ImageQuestionForm.scss';

class ImageQuestionForm extends Component {
  static propTypes = {
    block: genericQuestionPropType,
    readOnly: PropTypes.bool,
    inputField: PropTypes.func.isRequired,
    styling: propTypeBlockStyling,
    validator: PropTypes.arrayOf(PropTypes.func),
    cancelSubmit: PropTypes.func.isRequired,
    flushSubmit: PropTypes.func.isRequired,
  };

  componentWillUnmount() {
    this.props.cancelSubmit();
  }

  render() {
    const {
      block: {
        size,
        personalLabelType,
        layout,
        labelLayout,
        options,
        commentsEnabled,
        commentsLabel,
      },
      flushSubmit,
      readOnly,
      inputField,
      validator,
      styling,
    } = this.props;
    return (
      <div>
        <Field
          name="value"
          format={null}
          component={inputField}
          validate={validator}
          props={{
            size,
            personalLabelType,
            layout,
            labelLayout,
            options,
            styling,
          }}
        />
        <Field
          name="comments"
          component={CommentsField}
          onBlur={flushSubmit}
          props={{
            readOnly,
            className: styles.comments,
            disabled: isQuestionCommentsDisabled(this.props),
            commentsEnabled,
            commentsLabel,
            styling,
          }}
        />
      </div>
    );
  }
}

export default compose(
  debouncedReduxForm({
    form: 'ImageQuestionForm',
    isAutoSubmit: true,
  }),
  withTakerValidator,
)(ImageQuestionForm);
